import { CancelReasonTypeEnum } from 'app/models';

export class CancelReasonTypeModel {
    public static CancelB2bReasonTypeList: Array<any> = [
        { value: CancelReasonTypeEnum.PassengerNoShow, name: 'Passenger No Show' },
        { value: CancelReasonTypeEnum.PassengerWithChild, name: 'Passenger is with a child' },
        { value: CancelReasonTypeEnum.TooManyPassengersOrLuggage, name: 'Too many passengers or luggage' },
        { value: CancelReasonTypeEnum.Other, name: 'Other' }
	];

	public static CancelReasonTypeList: Array<any> = [
		{ value: CancelReasonTypeEnum.PassengerNoShow, name: 'Passenger No Show' },
		{ value: CancelReasonTypeEnum.CreatePaymentFailed, name: 'Create Payment Failed' },
		{ value: CancelReasonTypeEnum.Accident, name: 'Accident' },
		{ value: CancelReasonTypeEnum.DoubleBooking, name: 'Double booking' },
		{ value: CancelReasonTypeEnum.PassengerChangedMind, name: 'Passenger changed mind' },
		{ value: CancelReasonTypeEnum.PassengerHasDesignated, name: 'Passenger has a designated' },
		{ value: CancelReasonTypeEnum.Other, name: 'Other' }
	];

	public static CancelConnexReasonTypeList: Array<any> = [
		{ value: CancelReasonTypeEnum.PassengerChangedMind, name: 'Changed plans' },
		{ value: CancelReasonTypeEnum.BookedWrongDate, name: 'Booked wrong date' },
		{ value: CancelReasonTypeEnum.BookedWrongRoute, name: 'Booked wrong route' },
		{ value: CancelReasonTypeEnum.Accident, name: 'Emergency' },
		{ value: CancelReasonTypeEnum.Other, name: 'Other' }
	];
}
